import { LoaderFunctionArgs } from "react-router-dom"

import { fetchAPI } from "./api"

export async function metadataLoader({ request }: LoaderFunctionArgs) {
  const searchParams = new URL(request.url).searchParams
  const metadataUrl = searchParams.get("metadataUrl")!

  const metadata = await fetchAPI(metadataUrl)
  if (metadata.status === 404 || metadata.ok) return metadata.result ?? {}

  throw new Response(metadata.errors[0].errorMessage, { status: metadata.status })
}
